"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getData = exports.isEnabled = exports.setConfigurationAPIURL = exports.setDebugLog = exports.setFor = void 0;
const sorter_1 = require("../flipper/sorter");
const cross_fetch_1 = __importDefault(require("cross-fetch"));
const CACHE_TIMEOUT = 20000;
class ConfigCache {
    constructor() {
        this.retrieved = 0;
        this.cache = null;
    }
    isEnabled(key, forService, forUser, forClient) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const configs = yield this.getConfigs(forService, forUser, forClient);
            const enabled = configs && configs.has(key) && ((_a = configs.get(key)) === null || _a === void 0 ? void 0 : _a.enabled);
            debug(key, ':', enabled);
            return enabled;
        });
    }
    isValid() {
        const time = new Date().getTime();
        debug('isValid calling ');
        debug('Retrieved: ', this.retrieved);
        debug('Time: ', time);
        debug('Time-Timeout: ', time - CACHE_TIMEOUT);
        return this.retrieved > time - CACHE_TIMEOUT;
    }
    getConfigs(forService, forUser, forClient) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.isValid()) {
                yield this.updateCache();
            }
            debug('getConfigs calling');
            debug('Cache before apply: ', this.cache);
            let configs = (0, sorter_1.apply)(this.cache, forService, forUser, forClient);
            debug('Cache after apply', configs);
            return configs;
        });
    }
    getData(key, forService, forUser, forClient) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const configs = yield this.getConfigs(forService, forUser, forClient);
            const data = configs && configs.has(key) && ((_a = configs.get(key)) === null || _a === void 0 ? void 0 : _a.data) || null;
            debug(key, ':', data);
            return data;
        });
    }
    updateCache() {
        return __awaiter(this, void 0, void 0, function* () {
            debug('update cache calling');
            if (!configurationAPIURL) {
                console.error('Unable to update configuration cache: missing configuration api url');
                return;
            }
            try {
                const params = new URLSearchParams();
                if (this.forService)
                    params.set('for', this.forService);
                if (this.forUser)
                    params.set('user_id', this.forUser);
                if (this.forClient)
                    params.set('client_id', this.forClient);
                const controller = new AbortController();
                const id = setTimeout(() => controller.abort(), 3000);
                const url = `${configurationAPIURL}/configurations?${params.toString()}`;
                debug('URL: ', url);
                const resp = yield (0, cross_fetch_1.default)(url, {
                    method: 'GET',
                    signal: controller.signal,
                });
                clearTimeout(id);
                debug('Response status: ', resp.status);
                if (resp.status == 200) {
                    const obj = yield resp.json();
                    debug('JSON: ', obj);
                    this.cache = new Map(typeof Object.entries === 'function'
                        ? Object.entries(obj)
                        : Object.keys(obj).map((k) => [k, obj[k]]));
                    this.retrieved = new Date().getTime();
                }
            }
            catch (e) {
                console.error('Unable to update configuration cache: ', e);
            }
        });
    }
}
let configurationAPIURL = process.env.CONFIGURATION_API_URL;
let configCache = new ConfigCache();
let debug = (...data) => { };
function setFor(forService, forClient, forUser) {
    if (forService)
        configCache.forService = forService;
    if (forClient)
        configCache.forClient = forClient;
    if (forUser)
        configCache.forUser = forUser;
}
exports.setFor = setFor;
function setDebugLog(enable) {
    if (enable) {
        debug = (...data) => {
            console.log('[CONFIGURATION-API]', ...data);
        };
    }
    else {
        debug = (...data) => { };
    }
}
exports.setDebugLog = setDebugLog;
function setConfigurationAPIURL(newConfigurationAPIURL) {
    configurationAPIURL = newConfigurationAPIURL;
}
exports.setConfigurationAPIURL = setConfigurationAPIURL;
function isEnabled(key, forService, forUser, forClientID) {
    return __awaiter(this, void 0, void 0, function* () {
        return configCache.isEnabled(key, forService, forUser, forClientID);
    });
}
exports.isEnabled = isEnabled;
function getData(key, forService, forUser, forClientID) {
    return __awaiter(this, void 0, void 0, function* () {
        return configCache.getData(key, forService, forUser, forClientID);
    });
}
exports.getData = getData;
//# sourceMappingURL=client.js.map